import React, {useEffect, useState} from "react";
import TopNav from '../components/TopNav';
import Footer from '../components/Footer';
import Contactmodal from '../components/ContactModal';
import NewsletterSubscribe from '../components/NewsletterSubscribe';
import OptOutModal from '../components/OptOutModal';



import '../assets/css/style.css';

const Layout = ({ children, ...props }) => {

    useEffect(() => {
        
        const AOS = require("aos");
        AOS.init({
          once: true,
        });
    
    }, []);

    const cookieConsentStyle = {
        background: "#e3e3e3",
        color: "black",
        bottom: "10px",
        padding: "10px",
        "justify-content": "center"
    };    

    return (
        <>
        <style dangerouslySetInnerHTML={{__html: `
            main > .container {
                padding: 100px 15px 0;
            }

        `}} />
        <TopNav />
        {children}
        <Contactmodal />
        <OptOutModal />
        <NewsletterSubscribe />
        <Footer />
        </>
    )
}

export default Layout